import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleRight } from '@fortawesome/free-solid-svg-icons';

import 'Components/Utility/SaleButton.scss';

export default function SaleButton({
  dealsLive,
  buttonLink,
  bundles,
  moreDeals,
  dealsNumber,
  search,
  bundleFest,
}) {
  const rednderText = () => {
    if (dealsNumber > 0) {
      return (
        <FormattedMessage
          id="sale-button.view-all-button-number-two"
          defaultMessage="View all {dealsNumber} deals"
          values={{
            dealsNumber,
          }}
        />
      );
    }

    if (moreDeals) {
      return (
        <FormattedMessage
          id="sale-button.view-more-button"
          defaultMessage="View more deals"
        />
      );
    }

    if (bundles) {
      return (
        <FormattedMessage
          id="sale-button.view-all-button-bundles"
          defaultMessage="View all bundles"
        />
      );
    }

    if (bundleFest) {
      return (
        <FormattedMessage
          id="sale-button.bundlefest"
          defaultMessage="View BundleFest"
        />
      );
    }

    if (dealsLive > 0) {
      return (
        <FormattedMessage
          id="sale-button.view-all-button-number"
          defaultMessage="View all {dealsLive} deals"
          values={{
            dealsLive,
          }}
        />
      );
    }

    return (
      <FormattedMessage
        id="sale-button.view-all-button"
        defaultMessage="View all deals"
      />
    );
  };
  return (
    <div className="SaleButton">
      <Link
        to={{ pathname: `/${buttonLink}`, state: { from: window.location.pathname }, search: `${search}` }}
        className="btn btn-primary SaleButton__button"
      >
        <FontAwesomeIcon icon={faCircleRight} className="mr-2" />
        {rednderText()}
      </Link>
    </div>
  );
}

SaleButton.propTypes = {
  dealsLive: PropTypes.number,
  buttonLink: PropTypes.string,
  search: PropTypes.string,
  bundles: PropTypes.bool,
  moreDeals: PropTypes.bool,
  dealsNumber: PropTypes.number,
  bundleFest: PropTypes.bool,
};

SaleButton.defaultProps = {
  dealsLive: 0,
  buttonLink: '',
  search: '',
  bundles: false,
  moreDeals: false,
  dealsNumber: 0,
  bundleFest: false,
};
